import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import LoaderOverlay from "../../layout/components/LoaderOverlay";
import BookingTicket from "./components/ConfirmationStep/BookingTicket";
import SoftSignupPrompt from "../../account/components/SoftSignupPrompt";

interface ConfirmationStepProps {
  onAddAnotherEquipment: () => void;
}

function ConfirmationStep({ onAddAnotherEquipment }: ConfirmationStepProps) {
  const { t } = useTranslation();
  const reservations = useSelector(
    (state: RootState) => state.bookingCreation.reservations
  )!;
  const location = useSelector(
    (state: RootState) => state.bookingCreation.selectedLocation
  )!;
  const isLoading = !(location && reservations.length > 0);

  return (
    <>
      {isLoading ? (
        <LoaderOverlay open={isLoading} />
      ) : (
        <div className="flex flex-col justify-between">
          <div className="overflow-auto flex-grow">
            <BookingTicket
              location={location.name}
              reservations={reservations}
              amount={1}
            />
          </div>
          <div className="text-center text-black text-xl font-semibold mb-2 py-6">
            <button
              onClick={onAddAnotherEquipment}
              className="underline bg-transparent border-none cursor-pointer"
            >
              {t("book_location.confirmation.add_another_group")}
            </button>
          </div>
          <SoftSignupPrompt />
        </div>
      )}
    </>
  );
}

export default ConfirmationStep;
